import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Divider, HeaderBlock, LayoutBand, useAtSize } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { Arrow } from '@fs/zion-icon'
import { useCorrections } from '../../aam/AppAam/hooks/hooks'
import fourSquareIcon from '../assets/icon-four-square.svg'

const menuActionsCss = css`
  display: grid;
  grid-template-columns: 150px 1fr 150px;
  align-items: center;
  padding: 6px 0px 4px;
  @media (max-width: 799px) {
    grid-template-columns: 41px 1fr 41px;
  }
`

const titleCss = css`
  pointer-events: none;
`

const imageCss = css`
  width: 25px;
  height: 25px;
  background-color: transparent;
`

const menuCss = css`
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  line-height: 0;
  color: black;
  padding-right: 8px;

  &:hover {
    text-decoration: underline black;
  }

  > *:last-child {
    margin-left: 16px;
  }
`

const leftArrowCss = css`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-decoration: none;
  line-height: 0;
`

export default function DiscoveryExperienceHeader({ mainUrl, title, noLayoutBand = false }) {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const isCorrections = useCorrections()
  const [showLeftArrow, setShowLeftArrow] = React.useState(false)

  const menuLabel = t('discovery.activity.menu', 'Menu')

  const MenuText = () => {
    const menu = <span>{menuLabel}</span>
    return atSize({ default: <></>, lg: menu })
  }

  const path = window.location.pathname

  React.useEffect(() => {
    setShowLeftArrow(path !== mainUrl)
  }, [mainUrl, path])

  const Wrapper = noLayoutBand ? React.Fragment : LayoutBand

  return (
    <>
      <Wrapper>
        <div css={menuActionsCss}>
          {showLeftArrow && !isCorrections ? (
            <div css={leftArrowCss}>
              <Link to={mainUrl}>
                <Arrow direction="left" color="black" />
              </Link>
            </div>
          ) : (
            <div />
          )}
          <div css={titleCss}>
            <HeaderBlock heading={title} size="sm" as="h1" centered />
          </div>
          {!isCorrections && (
            <Link to="/discovery" external>
              <div css={menuCss}>
                <MenuText />
                <img src={fourSquareIcon} alt="Menu" css={imageCss} />
              </div>
            </Link>
          )}
        </div>
      </Wrapper>
      <Divider mode="middle" />
    </>
  )
}

DiscoveryExperienceHeader.propTypes = {}
